<template>
  <div
    v-if="afterDiscount"
    class="item-total-price"
    :class="`item-total-price--${layout}`"
  >
    <AkParagraph
      v-if="hasDiscount"
      :size="textSize"
      class="item-total-price__discount"
      data-testid="priceBeforeDiscount"
    >
      {{ formatPrice(beforeDiscount) }}
    </AkParagraph>
    <AkParagraph
      :class="{ 'item-total-price--discounted': hasDiscount }"
      :size="textSize"
      weight="bold"
      data-testid="actualPrice"
    >
      {{ formatPrice(afterDiscount)
      }}<span
        v-if="isUpperThanGlobalBrandDiscount"
        data-testid="extraDiscountLabel"
      >
        {{ t('global.asterisk') }}
      </span>
    </AkParagraph>
  </div>
</template>
<script lang="ts" setup>
import { AkParagraph } from '@ankorstore/design-system';
import { computed, PropType } from 'vue';
import { Amount } from '@core/types/amount';
import usePrice from '@core/composables/use-price';
import { useI18n } from 'vue-i18n';

defineOptions({
  name: 'ItemTotalPrice',
});
const props = defineProps({
  beforeDiscount: {
    type: Object as PropType<Amount>,
    required: true,
  },
  afterDiscount: {
    type: Object as PropType<Amount>,
    required: true,
  },
  textSize: {
    type: String as PropType<'base' | 'lg' | 'sm' | 'xs'>,
    default: 'base',
  },
  isUpperThanGlobalBrandDiscount: {
    type: Boolean,
    default: false,
    required: false,
  },
  layout: {
    type: String as PropType<'horizontal' | 'vertical'>,
    default: 'horizontal',
  },
});

const { formatPrice } = usePrice();
const { t } = useI18n();

const hasDiscount = computed<boolean>(() => {
  return !!props.beforeDiscount && props.beforeDiscount.amount > props.afterDiscount.amount;
});
</script>
<style lang="scss" scoped>
.item-total-price {
  @apply ds-flex ds-flex-col ds-gap-0 lg:ds-flex-row lg:ds-gap-4 ds-justify-end;
  &--vertical {
    @apply ds-flex-col ds-gap-0;
  }
  &__discount {
    @apply ds-line-through;
  }
  &--discounted {
    @apply ds-text-discount-700;
  }
}
</style>
